// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PatientFinderGender } from './patientFinderGender.js';
import type { PatientFinderPatientRequestAddress } from './patientFinderPatientRequestAddress.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PatientFinderPatientRequest {
    'address': Array<PatientFinderPatientRequestAddress>;
    'birthDate': Moment;
    'emailAddress'?: string;
    'firstName': string;
    'gender'?: PatientFinderGender;
    'lastName': string;
    'maritalStatus'?: string;
    'middleName'?: string;
    'nameSuffix'?: string;
    'phoneNumber'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PatientFinderPatientRequest>> = [
        {
            "name":     "address",
            "baseName": "address",
            "type":     "Array<PatientFinderPatientRequestAddress>"
        },
        {
            "name":     "birthDate",
            "baseName": "birthDate",
            "type":     "Date"
        },
        {
            "name":     "emailAddress",
            "baseName": "emailAddress",
            "type":     "string"
        },
        {
            "name":     "firstName",
            "baseName": "firstName",
            "type":     "string"
        },
        {
            "name":     "gender",
            "baseName": "gender",
            "type":     "PatientFinderGender"
        },
        {
            "name":     "lastName",
            "baseName": "lastName",
            "type":     "string"
        },
        {
            "name":     "maritalStatus",
            "baseName": "maritalStatus",
            "type":     "string"
        },
        {
            "name":     "middleName",
            "baseName": "middleName",
            "type":     "string"
        },
        {
            "name":     "nameSuffix",
            "baseName": "nameSuffix",
            "type":     "string"
        },
        {
            "name":     "phoneNumber",
            "baseName": "phoneNumber",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return PatientFinderPatientRequest.attributeTypeMap;
    }
}
